import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Typography, Button, Card, Input, Skeleton } from "antd";

import { ReactComponent as AddIcon } from "../../../../assets/images/company-structure-items/add.svg";
import { assignmentProgress as taskProgress } from "../../../../utils/helpers/calculateAssignmentProgress";
import { ReactComponent as SearchIcon } from "../../../../assets/images/search.svg";
import { default as TaskActiveCard } from "../../Assignment/View/AssignmentActiveCard";
import { default as SingleTaskCard } from "../../Assignment/View/SingleAssignmentCard";
import EmptyState from "../../../shared/EmptyState";
// import FilterByDepartments from "../../../shared/FilterByDepartments";
// import FilterByPositions from "../../../shared/FilterByPositions";

const { Text } = Typography;

const EducatorAssignmentsScreen = (props: any) => {
  const {
    tasks,
    task,
    loading,
    loaded,
    users,
    usersLoaded,
    actions: { getTask, getTaskById, getUser, deleteTask },
  } = props;

  const navigate = useNavigate();
  const [filteredTasks, setFilteredTasks] = useState<any>(tasks);
  const [searchTerm, setSearchTerm] = useState("");
  const [filter, setFilter] = useState("ALL");
  const filterProps = [
    { key: "ALL", value: "ALL" },
    { key: "UNFINISHED", value: "UNFINISHED" },
    { key: "FINISHED", value: "FINISHED" },
  ];
  const allTasks = filterProps[0];
  const unfinishedTasks = filterProps[1];
  const finishedTasks = filterProps[2];
  const [selectedDepartments, setSelectedDepartments] = useState<string[]>([]);
  const [selectedPositions, setSelectedPositions] = useState<string[]>([]);
  const [activeCard, setActiveCard] = useState<any>(null);

  useEffect(() => {
    if (!loaded) getTask();
    if (!usersLoaded) getUser();
  }, []);

  useEffect(() => {
    if (!activeCard) return;
    getTaskById({ id: activeCard.id });
  }, [activeCard]);

  useEffect(() => {
    if (tasks.length === 0 || window.innerWidth < 1200) return;
    document.body.classList.add("assignment-layout");

    return () => {
      document.body.classList.remove("assignment-layout");
    };
  }, [tasks]);

  useEffect(() => {
    let filtered = tasks;

    if (filter === "FINISHED") {
      filtered = filtered.filter((task: any) => taskProgress(task) === 100);
    } else if (filter === "UNFINISHED") {
      filtered = filtered.filter((task: any) => taskProgress(task) !== 100);
    }

    if (searchTerm) {
      filtered = filtered.filter((task: any) =>
        task.title.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    setFilteredTasks(filtered);
  }, [tasks, searchTerm, filter]);

  const handleDelete = () => {
    deleteTask({ id: task.id });
    setActiveCard(null);
  };

  const handleDepartmentChange = (departments: string[]) => {
    setSelectedDepartments(departments);
    setActiveCard(null);

    let query = "";
    for (let i = 0; i < departments.length; i++) {
      query += "departmentIds=" + departments[i] + "&";
    }
    for (let i = 0; i < selectedPositions.length; i++) {
      query += "positionIds=" + selectedPositions[i] + "&";
    }

    getTask({
      query,
    });
  };

  const handlePositionChange = (positions: string[]) => {
    setSelectedPositions(positions);
    setActiveCard(null);

    let query = "";
    for (let i = 0; i < positions.length; i++) {
      query += "positionIds=" + positions[i] + "&";
    }
    for (let i = 0; i < selectedDepartments.length; i++) {
      query += "departmentIds=" + selectedDepartments[i] + "&";
    }

    getTask({
      query,
    });
  };

  if (loading) {
    return <Skeleton active />;
  }

  return (
    <>
      {tasks ? (
        <div className="xl:flex">
          <div className="xl:w-[42.4%] xl:pr-[70px]">
            <div className="sticky">
              <Input
                placeholder="Search"
                prefix={<SearchIcon className="mx-3" />}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <div className="flex justify-between items-center my-5">
                <div className="flex gap-3">
                  <Button
                    type="link"
                    onClick={() => {
                      setFilter(allTasks.value);
                      setActiveCard(null);
                    }}
                    className={
                      filter === allTasks.value
                        ? "text-primary-600 font-semibold px-0 text-xs"
                        : "text-neutral-400 font-normal px-0 text-xs"
                    }
                  >
                    {allTasks.key}
                  </Button>
                  <Button
                    type="link"
                    onClick={() => {
                      setFilter(unfinishedTasks.value);
                      setActiveCard(null);
                    }}
                    className={
                      filter === unfinishedTasks.value
                        ? "text-primary-600 font-semibold px-0 text-xs"
                        : "text-neutral-400 font-normal px-0 text-xs"
                    }
                  >
                    {unfinishedTasks.key}
                  </Button>
                  <Button
                    type="link"
                    onClick={() => {
                      setFilter(finishedTasks.value);
                      setActiveCard(null);
                    }}
                    className={
                      filter === finishedTasks.value
                        ? "text-primary-600 font-semibold px-0 text-xs"
                        : "text-neutral-400 font-normal px-0 text-xs"
                    }
                  >
                    {finishedTasks.key}
                  </Button>
                </div>
                {/* <div className="flex">
                  <FilterByDepartments
                    onSelectionChange={handleDepartmentChange}
                    selectedDepartments={selectedDepartments}
                    setSelectedDepartments={setSelectedDepartments}
                  />
                  <FilterByPositions
                    onSelectionChange={handlePositionChange}
                    selectedPositions={selectedPositions}
                    setSelectedPositions={setSelectedPositions}
                  />
                </div> */}
                <div className="xl:hidden">
                  <Button
                    onClick={() => navigate("/educator/task/create")}
                    className="h-[40px]  border-none shadow-md rounded-lg"
                  >
                    <AddIcon />
                    <Text className="text-sm font-semibold text-neutral-600">
                      Add New Task
                    </Text>
                  </Button>
                </div>
              </div>

              <div>
                <div className="flex flex-col gap-4 pb-[60px]">
                  {activeCard && (
                    <>
                      <Card className={`p-6 border-none shadow-md  `}>
                        <SingleTaskCard
                          content={activeCard}
                          isActive
                          isAssignmentPage={false}
                        />
                      </Card>
                      <div className="border-b border-primary-200 my-3"></div>
                    </>
                  )}
                  {filteredTasks && filteredTasks.length > 0 ? (
                    filteredTasks.map((task: any, index: number) => (
                      <Card
                        key={index}
                        onClick={() => setActiveCard(task)}
                        className={`p-4 py-6 cursor-pointer border-none shadow-sm 
                            ${task.id === activeCard?.id && "hidden"}
                           `}
                      >
                        <SingleTaskCard
                          content={task}
                          isAssignmentPage={false}
                        />
                      </Card>
                    ))
                  ) : (
                    <div className="flex items-center justify-center h-full pb-[60px]">
                      <EmptyState />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="xl:w-[57.6%] xl:pl-[70px] pb-[60px]">
            <div className="hidden xl:flex justify-end mb-[72px]">
              <Button
                onClick={() => navigate("/educator/task/create")}
                className="h-[50px] w-1/2 border-none shadow-md rounded-lg"
              >
                <AddIcon />
                <Text className="text-sm font-semibold text-neutral-600">
                  Add New Task
                </Text>
              </Button>
            </div>
            {activeCard && (
              <TaskActiveCard
                percentage={activeCard}
                content={task}
                users={users}
                onDelete={handleDelete}
                isAssignmentPage={false}
              />
            )}
          </div>
        </div>
      ) : (
        <div className="flex items-center justify-center h-full pb-[60px]">
          <EmptyState />
        </div>
      )}
    </>
  );
};

export default EducatorAssignmentsScreen;
